'use strict';

/* eslint-env browser */
module.exports = typeof self === 'object' ? self.FormData : window.FormData;



//////////////////
// WEBPACK FOOTER
// ./~/form-data/lib/browser.js
// module id = 1140
// module chunks = 0